import { ConfigurationObjectFeatureFlagProvider, FeatureManager } from '@microsoft/feature-management'
import axios from 'axios'
import { FeatureFlag } from 'src/config/featureFlags'

const API_BASE = '/api/app-config'

export class FeatureFlagService {
    private static featureManger: FeatureManager

    private static async init() {
        const { data } = await axios.get(API_BASE)
        const ffProvider = new ConfigurationObjectFeatureFlagProvider(data)
        this.featureManger = new FeatureManager(ffProvider)
    }

    public static async isEnabled(feature: FeatureFlag): Promise<boolean> {
        try {
            if (!this.featureManger) {
                await this.init()
            }
            return await this.featureManger.isEnabled(feature.toString())
        } catch (ex) {
            console.error(ex)
        }
        return false
    }
}
